
  document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.lum-featured-slider-section');
    
    sliders.forEach(slider => {
      const slides = Array.from(slider.querySelectorAll('.lum-feature--slide'));
      const dots = slider.querySelectorAll('.lum-feature--dot');
      let currentIndex = 1; // Default center
      
      // Handle Heading Color
      const heading = slider.querySelector('.lum-feature--heading');
      if (heading) {
        const text = heading.innerText;
        if (text.includes('—')) {
          const parts = text.split('—');
          if (parts.length > 1) {
            heading.innerHTML = `${parts[0]} — <span class="highlight">${parts[1]}</span>`;
          }
        }
      }

      function updateSlides(index) {
        slides.forEach(slide => {
          slide.classList.remove('active', 'prev', 'next');
          slide.style.opacity = '0';
          slide.style.zIndex = '0';
        });
        
        dots.forEach(dot => dot.classList.remove('active'));
        if(dots[index]) dots[index].classList.add('active');

        const total = slides.length;
        const prevIndex = (index - 1 + total) % total;
        const nextIndex = (index + 1) % total;
        
        // Active
        slides[index].classList.add('active');
        slides[index].style.opacity = '1';
        
        // Prev
        slides[prevIndex].classList.add('prev');
        slides[prevIndex].style.opacity = '1';
        
        // Next
        slides[nextIndex].classList.add('next');
        slides[nextIndex].style.opacity = '1';
      }

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          currentIndex = i;
          updateSlides(currentIndex);
        });
      });
      
      // Initialize
      if (slides.length >= 3) {
        currentIndex = 1;
      } else {
        currentIndex = 0;
      }
      updateSlides(currentIndex);
    });
  });